export enum EVENT_PROGRESS {
  UPCOMING = 1,
  NOW = 2,
  PAST = 3,
}
